import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const sendEmailApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.MESSAGING.SEND_EMAIL)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
